<template>
	<div data-tour-scope="setting-thumbnail">
		<v-main>
			<v-container fluid fill-height>
				<v-layout column justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.thumbnail') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-btn depressed color="primary" data-tour="add" @click="apriNuova"><v-icon left>mdi-plus</v-icon>Nuova miniatura</v-btn>
						</v-toolbar>
						<!-- telefono: ogni miniatura diventa una card -->
						<div v-if="mobileCards" class="kv-list thumbnail-cards pa-3" data-tour="table">
							<key-value-card v-for="(item, index) of thumbnails" :key="item.size" :title="item.size + ' px'">
								<template v-slot:actions>
									<v-menu left eager>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === 0 ? 'row-menu' : null">
												<v-icon>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item link @click="apriModifica(item)">
												<v-list-item-title class="size9">Modifica</v-list-item-title>
											</v-list-item>
											<v-list-item link @click="deleteItem(item)">
												<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</template>
							</key-value-card>
							<div v-if="thumbnails.length === 0" class="grey--text text-center py-4">Nessuna miniatura</div>
						</div>
						<v-simple-table v-else data-tour="table">
							<template v-slot:default>
								<thead>
									<tr>
										<th style="width: 40px"></th>
										<th class="text-left">Miniatura</th>
										<th class="text-left">Proporzione</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="!thumbnails.length">
										<td colspan="3" class="grey--text text-center">Nessuna miniatura: aggiungila con "Nuova miniatura"</td>
									</tr>
									<tr v-for="(item, index) of thumbnails" :key="item.size">
										<td class="pl-0 pr-0" style="width: 40px">
											<v-menu right eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === 0 ? 'row-menu' : null">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="apriModifica(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td class="font-weight-medium">{{ item.size }} px</td>
										<td>
											<!-- barra proporzionale alla miniatura piu' grande -->
											<div class="th-bar"><div class="th-bar-fill" :style="{ width: proporzione(item) + '%' }"></div></div>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>
					<ImageServices />
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>

		<ThumbnailDialog v-model="dialogMisura" :esistenti="thumbnails.map(t => t.size)" :modifica="inModifica ? inModifica.size : null" @save="salvaMisura" />

		<v-dialog v-model="dialogconfirm" max-width="360">
			<v-card>
				<v-card-title class="headline">Eliminare la miniatura da {{ daEliminare ? daEliminare.size : '' }} px?</v-card-title>
				<v-card-text>Le immagini caricate da qui in poi non avranno più questa misura.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ThumbnailDialog from './components/ThumbnailDialog.vue';
import ImageServices from './components/ImageServices.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createThumbnailTourSteps } from './thumbnail-tour';
/*import SocketIO from 'socket.io-client'
var socket= SocketIO({
    debug: true,
    connection: 'http://127.0.0.1:4000'
})*/

//var socket = io('127.0.0.1:4000')
//console.log(socket)
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
//import moment from 'vue-moment';

export default {
	name: 'Thumbnail',
	setup() {
		return { tour: useTour(createThumbnailTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					payments: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			dialogMisura: false,
			// miniatura aperta nel dialog di modifica (null = nuova)
			inModifica: null,
			// miniatura in attesa di conferma nel dialog di eliminazione
			daEliminare: null,

			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: 'Lingua', value: '' },
				{ text: 'Status', value: '' },
				{ text: 'Default', value: '' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			form: {
				size: '',
			},
			thumbnails: [],
		};
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},

	async created() {
		this.setPreload(true);
		await this.fetchSettings();

		this.thumbnails = this.getSettings.thumbnails != undefined ? this.getSettings.thumbnails : [];
		this.setPreload(false);
	},

	watch: {
		settings: {},
	},
	components: {
		TourOverlay,
		KeyValueCard,
		ThumbnailDialog,
		ImageServices,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',
		}),
		/*Totale(){
        console.log(filteredItems)
        /!*if(filteredItems.length>0) {
            return filteredItems.reduce((total, current) => {
                return total + parseFloat(current.Total)
            })

        }*!/
    },*/
		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),

		// la lista si salva sempre intera (POST profile/thumbnails): ritorna true se il server l'ha accettata
		async salvaThumbnails(lista) {
			this.setPreload(true);
			try {
				const { data } = await axios.post(`${this.getUrl}profile/thumbnails`, lista, { headers: { Authorization: `Bearer ${this.getToken}` } });
				this.setSettings(data.data);
				this.thumbnails = data.data && Array.isArray(data.data.thumbnails) ? data.data.thumbnails : lista;
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return true;
			} catch (err) {
				if (err.response) {
					const errors = err.response.data.error;
					if (errors && !_.isArray(errors)) err.message = errors;
					if (err.response.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				}
				this.snackbar.color = 'error';
				this.snackbar.text = err.message;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return false;
			} finally {
				this.setPreload(false);
			}
		},
		apriNuova() {
			this.inModifica = null;
			this.dialogMisura = true;
		},
		apriModifica(item) {
			this.inModifica = item;
			this.dialogMisura = true;
		},
		// arriva dal dialog gia' validata
		async salvaMisura(size) {
			const lista = this.inModifica ? this.thumbnails.map(t => (t === this.inModifica ? { ...t, size } : t)) : [...this.thumbnails, { size }];
			const ok = await this.salvaThumbnails(lista);
			if (ok) {
				this.dialogMisura = false;
				this.inModifica = null;
			}
		},
		// larghezza della barra in tabella, rispetto alla miniatura piu' grande
		proporzione(item) {
			const max = Math.max(...this.thumbnails.map(t => +t.size || 0), 1);
			return Math.max(Math.round(((+item.size || 0) / max) * 100), 2);
		},
		async confirmDelete() {
			this.dialogconfirm = false;
			const item = this.daEliminare;
			this.daEliminare = null;
			if (item) await this.salvaThumbnails(this.thumbnails.filter(t => t !== item));
		},
		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},

		resetForm() {
			this.form.size = '';
		},

		checkpresenza(item) {
			return this.selected.includes(item);
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				var response = await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
	},
};
</script>

<style></style>

<style scoped>
.th-bar {
	width: 160px;
	height: 8px;
	border-radius: 4px;
	background: #eef2f7;
	overflow: hidden;
}
.th-bar-fill {
	height: 100%;
	background: #1565c0;
	border-radius: 4px;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.thumbnail-cards,
.thumbnail-cards tr {
	display: block;
	width: 100%;
}
.thumbnail-cards tr,
.thumbnail-cards tr:hover {
	background: transparent !important;
}
.thumbnail-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.thumbnail-cards tr:first-child td {
	padding-top: 12px !important;
}
.thumbnail-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.thumbnail-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
